// extracted by mini-css-extract-plugin
export default {"status":"Tags_status__SzQ2K","green":"Tags_green__gWLBo","orange":"Tags_orange__osl2n","failed":"Tags_failed__p7E+a","red":"Tags_red__mXOxv","gray":"Tags_gray__O+HGP"};